export default [
    {
        path: '/',
        name: 'PIC',
        meta: {},
        component: () => import('../views/pages/user/pic')
    },
    {
        path: '/pic',
        name: 'PIC',
        meta: {},
        component: () => import('../views/pages/user/pic')
    },
    {
        path: '/name-card',
        name: 'NAMECARD',
        meta: {},
        component: () => import('../views/pages/user/staff')
    },
]
